import {Component, Input} from '@angular/core';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {GenericCardComponent} from "src/app/components/generic-card-component/generic-card.component";
import {NgIf, NgStyle} from "@angular/common";
import {RouterLink} from "@angular/router";
import {CustomIconService} from "@app/config/custom-icon.service";
import {SiteNavbarComponent} from "src/app/components/site-navbar/site-navbar.component";

@Component({
  selector: 'app-centered-card-layout',
  templateUrl: './centered-card-layout.component.html',
  styleUrls: ['./centered-card-layout.component.scss'],
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, GenericCardComponent, NgIf, RouterLink, SiteNavbarComponent, NgStyle]
})
export class CenteredCardLayoutComponent {
  @Input() title!: string;
  @Input() subtitle: string = '';
  @Input() backgroundImgSrc: string | null = null;
  @Input() backgroundImgSrcUrl: string | null = null;

  constructor(private iconService: CustomIconService) {
    this.iconService.loadSvgIcons(['brand-logo']);
  }

  getBackgroundStyle(): any {
    const imageUrl = this.backgroundImgSrcUrl || this.backgroundImgSrc;
    if (imageUrl) {
      return {'background-image': `url(${imageUrl})`};
    }
    return null;
  }
}
